import React, { useCallback } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import { FunctionType, PermissionType } from '../../const/UserPermission';

import { Button } from '../atoms/Button';
import { useCommonModal } from '../../redux/common_modal/useCommonModal';

interface Props {
  title: string;
  description: string;
  image: string;
  color: string;
  submit: () => void;
  showCv: boolean;
}

export const QuestionMv: React.FC<Props> = ({
  title,
  description,
  image,
  color,
  submit,
  showCv,
}) => {
  const { openModal } = useCommonModal();

  const handleClick = useCallback(() => {
    if (openModal(FunctionType.Question, PermissionType.Create)) return;
    submit();
  }, [openModal, submit]);

  return (
    <>
      {showCv && (
        <Wrapper bg={color}>
          <H2>{title}</H2>
          <Description>{description}</Description>
          <StyledButton border onClick={handleClick}>
            質問してみる
          </StyledButton>
          <Image image={image} />
        </Wrapper>
      )}
    </>
  );
};

const Wrapper = styled.div<{ bg: string }>`
  margin-bottom: 2rem;
  padding: 2rem 23.5rem 1.5rem 2rem;
  background: ${(props) => props.bg};
  position: relative;

  ${media.lessThan('large')`
    padding-right: 18.5rem;
  `}

  ${media.lessThan('medium')`
    display: flex;
    flex-direction: column;
    padding: 2rem;
  `}

  ${media.lessThan('small')`
    padding: 2rem 1rem;
  `}
`;
const H2 = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.5;

  ${media.lessThan('medium')`
    order: 1;
  `}

  ${media.lessThan('small')`
    font-size: 1.25rem;
  `}
`;
const Description = styled.p`
  margin-top: 1.5rem;
  font-size: 1rem;
  line-height: 1.5;

  ${media.lessThan('medium')`
    order: 2;
  `}

  ${media.lessThan('small')`
    margin-top: 1rem;
  `}
`;
const StyledButton = styled(Button)`
  display: block;
  width: 100%;
  max-width: 10rem;
  margin: 2.25rem auto 0 0;

  ${media.lessThan('medium')`
    order: 4;
    max-width: 14.5rem;
    margin: .625rem auto 0;
  `}
`;

const Image = styled.div<{ image: string }>`
  width: 100%;
  max-width: 18.75rem;
  height: 100%;
  max-height: 12.5rem;
  background: url(${(props) => props.image}) center bottom / contain no-repeat;
  position: absolute;
  bottom: 0;
  right: 3rem;

  ${media.lessThan('large')`
    max-width: 14.75rem;
    right: 2rem;
  `}

  ${media.lessThan('medium')`
    order: 3;
    max-width: 100%;
    height: 12.5rem;
    max-height: none;
    position: static;
  `}

  ${media.lessThan('small')`
    height: 10rem;
  `}
`;
